<div class="container">
  <ngx-spinner></ngx-spinner>

  <div class="search-form">
    <form (ngSubmit)="onSearch()" class="search-form">
      <div class="search-fields">
        <mat-form-field appearance="fill">
          <mat-label>Full Name</mat-label>
          <input matInput [(ngModel)]="searchForm.fullName" name="fullName" placeholder="Search by name" appTextNormalize>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Age From</mat-label>
          <input matInput type="number" [(ngModel)]="searchForm.ageFrom" name="ageFrom" placeholder="Min age">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Age To</mat-label>
          <input matInput type="number" [(ngModel)]="searchForm.ageTo" name="ageTo" placeholder="Max age">
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Gender</mat-label>
          <mat-select [(ngModel)]="searchForm.gender" name="gender">
            <mat-option [value]="null">(None)</mat-option>
            <mat-option [value]="1">Male</mat-option>
            <mat-option [value]="2">Female</mat-option>
            <mat-option [value]="0">Unknown</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Nationality</mat-label>
          <mat-select [(ngModel)]="searchForm.nationalityId" name="nationalityId">
            <mat-option value="">(None)</mat-option>
            @for (nat of nationalities; track nat.id) {
              <mat-option [value]="nat.id">{{ nat.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Profession</mat-label>
          <mat-select [(ngModel)]="searchForm.professionId" name="professionId">
            <mat-option value="">(None)</mat-option>
            @for (prof of professions; track prof.id) {
              <mat-option [value]="prof.id">{{ prof.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="search-actions">
        <mat-checkbox [(ngModel)]="showBoardMemberships" name="showBoardMemberships" color="primary">Show Board Memberships</mat-checkbox>
        <div class="search-actions-spacer"></div>
        <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="onClear()" [disabled]="!hasSearchCriteria">
          <mat-icon>clear</mat-icon>
          Clear
        </button>
        <button mat-flat-button color="primary" type="submit" [disabled]="!hasSearchCriteria">
          <mat-icon>search</mat-icon>
          Search
        </button>
      </div>
    </form>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2" [hidden]="!dataSource.data || dataSource.data.length === 0">
      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Full Name</th>
        <td mat-cell *matCellDef="let item">
          <span class="name-cell" [class.deceased]="item.isDeceased">
            <a class="director-edit-btn" title="View / Edit director" (click)="editRequested.emit(item); $event.stopPropagation()">
              <mat-icon>open_in_new</mat-icon>
            </a>
            {{ item.fullName }}
            @if (item.isDeceased) {
              <mat-icon class="deceased-icon" title="Passed away{{ item.dateOfDeath ? ' (' + (item.dateOfDeath | date:'dd/MM/yyyy') + ')' : '' }}">warning</mat-icon>
            }
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="age">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Age</th>
        <td mat-cell *matCellDef="let item">{{ getDisplayAge(item) }}</td>
      </ng-container>

      <ng-container matColumnDef="nationalityName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nationality</th>
        <td mat-cell *matCellDef="let item">{{ item.nationalityName }}</td>
      </ng-container>

      <ng-container matColumnDef="boardMemberships">
        <th mat-header-cell *matHeaderCellDef>Board Memberships</th>
        <td mat-cell *matCellDef="let item">
          <ul class="list-column">
            @for (m of getBoardMemberships(item); track m.label) {
              <li>{{ m.label }}</li>
            }
          </ul>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item">
          <button mat-icon-button (click)="onConnect(item)">
            <mat-icon>{{ isSelected(item) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'right-row': isSelected(row)}"></tr>
    </table>

    @if (hasSearched && dataSource.data.length === 0) {
      <div class="empty-state">
        <p>No directors found matching your criteria.</p>
        <button mat-flat-button color="primary" (click)="addNewRequested.emit()">
          <mat-icon>person_add</mat-icon>
          Create New Director
        </button>
      </div>
    } @else if (!hasSearched) {
      <div class="empty-state">
        Search for an existing director to add to the board.
      </div>
    }

    <mat-paginator
      [pageSize]="pageSize"
      [showFirstLastButtons]="true"
      [hidden]="!dataSource.data || dataSource.data.length === 0"
      aria-label="Select page">
    </mat-paginator>
  </div>
</div>
